import { createSelector } from '@ngrx/store';
import { profileFeature } from '../reducers/profile.reducers';

export const selectAllEstablishmentFases = createSelector(
  profileFeature.selectProfiles,
  (profiles) => profiles?.map((profile) => profile.establishmentFase)
);

export const selectAllProfiles = createSelector(
  profileFeature.selectProfiles,
  (profiles) => profiles
);
